export default __webpack_public_path__ + "static/media/service-eight-bg.93ef1318.png";